const professions = [
  { id: "-1", name: "Please select type" },
  { id: "1", name: "Estate agent" },
  { id: "2", name: "Valuer" },
  { id: "3", name: "Advocate" },
  { id: "4", name: "Other" },
];

export default professions;
